import React, { useState } from "react";
import { SelectList } from "@common/selectList";
import { LayoutWatcher } from "@common/layoutWatcher";
import { ScreenWatcher } from "@common/screenWatcher";
import { Props } from "./types";
import { MoreIcon } from "./moreIcon";
import styles from "./styles.scss";
import classNames from "classnames";

function ContextualMenu({ items, className, openedClassName }: Props) {
  const height = items.length * 35;

  return (
    <LayoutWatcher
      renderChildren={({ top }) => (
        <ScreenWatcher
          renderChildren={(screen) => (
            <SelectList
              rootClassName={(isVisible) =>
                classNames(className, { [`${openedClassName}`]: isVisible })
              }
              listClassName={classNames(styles.list, {
                [styles.up]: height + top >= screen.height,
              })}
            >
              {({ isOpen, select }) => ({
                input: (
                  <div className={styles.button}>
                    <MoreIcon className={styles.moreIcon} />
                  </div>
                ),
                list: (
                  <div className={styles.menu}>
                    {items.map((item) => (
                      <div
                        className={styles.action}
                        key={item.name}
                        onClick={() => {
                          item.act();
                          select(item);
                        }}
                      >
                        {item.renderIcon && item.renderIcon(styles.icon)}
                        <p style={{ color: item.color }}>{item.name}</p>
                      </div>
                    ))}
                  </div>
                ),
              })}
            </SelectList>
          )}
        />
      )}
    />
  );
}

export { ContextualMenu };
